import { useMemo } from 'react'

import type { DxTradeOrder, DxTradeOrderExecution } from '@model/DxTrade.types'

export function useClosePrice(order?: DxTradeOrder): number | null {
  return useMemo(() => getClosePrice(order), [order])
}

export function getClosePrice(order?: DxTradeOrder): number | null {
  if (!order?.executions || order.executions.length === 0) return null
  const completedExecutions = order.executions.filter(
    (execution: DxTradeOrderExecution) => execution.status === 'COMPLETED'
  )
  if (completedExecutions.length === 0) return null
  const latestExecution = completedExecutions.sort(
    (a, b) => new Date(b.transactionTime).getTime() - new Date(a.transactionTime).getTime()
  )[0]
  return latestExecution?.lastPrice ?? null
}
